export function getFieldName(fieldFullName) {
    let split = fieldFullName.split(".");
    return split[split.length - 1];
}
;
export const isRequired = (val) => !!val;
export function formatPhone(val) {
    if (val === undefined) {
        return;
    }
    var firstThree = val.substring(0, 3);
    var secondThree = val.substring(3, 6);
    var thirdFour = val.substring(6, 10);
    if (firstThree) {
        val = '(' + firstThree;
    }
    if (secondThree) {
        val += (') ' + secondThree);
    }
    if (thirdFour) {
        val += ('-' + thirdFour);
    }
    return val;
}
export function parseMobile(val) {
    return val.replace(/\D+/g, '').substring(0, 10);
}
import { actions } from 'react-redux-form';
import { notifier } from "common/notifier";
export const formAsynSubmit = (dispatch, modelPath, asyncCall, onSuccess, onFailure, resetForm = true, autoDismissErrorTimeout = 5) => {
    const submitPromise = new Promise((resolve, reject) => {
        asyncCall.then(() => {
            // Update path
            onSuccess(dispatch);
            // Clear the form
            if (resetForm) {
                dispatch(actions.reset(modelPath));
            }
            // Indicate that form is valid
            resolve();
        }, (message) => {
            // Set server error on form
            //reject({ serverError: message });
            notifier.notifyError("Error", message, autoDismissErrorTimeout);
            onFailure(dispatch);
        });
    });
    // Dispath form actions
    dispatch(actions.submit(modelPath, submitPromise));
};
